// @ts-nocheck
import AboutTrip from '../AboutTrip/AboutTrip';
import CustomTabs from '../../Tabs/CustomTabs';
import CustomTab from '../../Tabs/CustomTab';
import DetailedView from '../DetailedView/DetailedView';
import AdditionalContent from '../AdditionalContent/AdditionalContent';
import ImagePicker from '../../../components/Upload/ImagePicker/ImagePicker';
import { fileType, pathReference } from '../../../constants/files';
import { getOldCoverImageUrl } from '../../../utils/getCoverImageUrl';
import LibrarySlide from '../Library/LibrarySlide/LibrarySlide';
import TripPassengerFieldsPanel from '../TripPassengerFields/TripPassengerFieldsPanel/TripPassengerFieldsPanel';
import { addTripImage } from '../../../services/trip/trip';
import { DragDropContext } from 'react-beautiful-dnd';
import { Books, PlusCircle } from '@phosphor-icons/react';
import { updateTrip } from '../../../redux/slices/trip/trip';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { getLastListItem } from '../../../utils/common';
import { XGButton } from '@xg-cl/xg-cl';
import { useEffect, useState } from 'react';
import { t } from 'i18next';
import {
  CREATENEWDAY,
  CREATE_NEW_ADDITIONAL_CONTENT,
  UPDATEDAYCONTENT,
  REORGANIZEDAYS,
  CONTENT_LIBRARY_DROPPABLE_ID,
  TRIP_DAYS_DROPPABLE_ID,
  TRIP_DAY_CONTENT_DROPPABLE_ID,
  TRIP_DAY_LINEITEM_DROPPABLE_ID,
  REORGANIZE_ADDITIONAL_ITEMS,
  TRIP_CONTENT_LIST_DROPPABLE_ID,
  TRIP_CONTENT_ITEM_DROPPABLE_ID,
  UPDATE_ADDITIONAL_CONTENT,
  TRIP_AMENITIES_TABLE_DROPPABLE_ID,
  ADD_AMENITY_FROM_LIBRARY,
  REORGANIZE_AMENITIES,
  ITINERARY_SERVICE_LIBRARY_DROPPABLE_ID,
  ADD_ITINERARY_SERVICE_FROM_LIBRARY
} from '../../../constants/dragAndDrop';
import {
  addIsDragging,
  addDraggableStatus,
  cleanDraggableStatus,
  addDraggableAction,
  addShouldLibraryClose
} from '../../../redux/slices/library/library';
import * as PropTypes from 'prop-types';
import './Itinerary.css';
import '../../Draggable/Draggable.css';
import ServiceTypesTabPanel from '../Services/ServiceTypesTabPanel/ServiceTypesTabPanel';
import DetailedItinerary from '../DetailedItinerary/DetailedItinerary';
import { useFlags, useLDClient } from 'launchdarkly-react-client-sdk';
import AmenitiesTable from '../../GlobalSettings/AmenitiesPanel/AmenitiesTable/AmenitiesTable';
import useTripAmenities from '../../../hooks/useTripAmenities';
import DeleteModal from '../DeleteModal/DeleteModal';

/**
 * Functional React component for rendering a custom itinerary content for a trip.
 *
 * @namespace Components
 *
 * @param {Object} props - The component's properties
 * @param {string} [props.id] - The ID for the trip itinerary component.
 * @param {...any} props.rest - Additional props to be spread on the Box element.
 *
 * @returns {JSX.Element} React element representing the trip itinerary.
 */

const Itinerary = ({ id, ...rest }) => {
  const trip = useSelector((state) => state.trip);
  const shouldLibraryClose = useSelector(
    (state) => state.library?.shouldLibraryClose ?? true
  );
  const dispatch = useDispatch();
  const { tripid, tripimage, tenant } = trip;
  const tripImage = getLastListItem(tripimage);
  const [openedTab, setOpenedTab] = useState(0);
  const [showLibraryButton, setsShowLibraryButton] = useState(false);
  const ldClient = useLDClient();
  const { ShowServiceTypes, ShowServicesFunctionality } = useFlags();

  const {
    amenitiesList,
    isSubmitting,
    isAddAmenityFormVisible,
    isDeleteModalOpen,
    handleDeleteAmenityConfirmation,
    handleUpdateAmenity,
    handleDeleteAmenity,
    handleUpdateSequence,
    setIsAddAmenityFormVisible,
    setAmenitiesList,
    setIsDeleteModalOpen,
    setDeleteAmenityId
  } = useTripAmenities(tripid);

  const updateTripCoverImage = async (newImageUrl) => {
    const { data } = await addTripImage(tripid, { imageUrl: newImageUrl });
    if (data) {
      const { tripimageid, seq, imageurl } = data;

      dispatch(
        updateTrip({
          tripimage: [
            {
              tripimageid,
              seq,
              imageurl
            }
          ]
        })
      );
      return { data: true };
    }

    return { data: false };
  };

  const handleSlideOpen = () => {
    dispatch(addShouldLibraryClose({ shouldLibraryClose: false }));
  };

  const handleSlideClose = () => {
    dispatch(addShouldLibraryClose({ shouldLibraryClose: true }));
  };

  const handleTabChange = (newValue) => {
    if (openedTab !== newValue) {
      handleSlideClose();
    }

    setOpenedTab(newValue);
  };

  const onDragStart = (data) => {
    const { source, destination } = data;

    dispatch(addIsDragging({ isDragging: true }));

    if (source?.droppableId === TRIP_DAYS_DROPPABLE_ID) {
      dispatch(
        addDraggableStatus({
          context: 'itinerary',
          data: {
            isTripDaysDraggableDisabled: false,
            isDayContentDraggableDisabled: true,
            isLibraryDraggableDisabled: true,
            isDayLineItemDraggableDisabled: true,
            isDayLibraryServiceDraggableDisabled: true
          }
        })
      );
    } else if (source?.droppableId === CONTENT_LIBRARY_DROPPABLE_ID) {
      const data =
        destination?.droppableId === ITINERARY_SERVICE_LIBRARY_DROPPABLE_ID
          ? {
              isTripDaysDraggableDisabled: true,
              isDayContentDraggableDisabled: true,
              isLibraryDraggableDisabled: true,
              isDayLineItemDraggableDisabled: true,
              isTripContentListDraggableDisabled: true,
              isTripContentDataDraggableDisabled: true,
              isTripAmenitiesTableDraggableDisabled: true,
              isDayLibraryServiceDraggableDisabled: false
            }
          : {
              isTripDaysDraggableDisabled: false,
              isDayContentDraggableDisabled: false,
              isLibraryDraggableDisabled: false,
              isDayLineItemDraggableDisabled: true,
              isTripContentListDraggableDisabled: false,
              isTripContentDataDraggableDisabled: false,
              isTripAmenitiesTableDraggableDisabled: false
            };
      dispatch(
        addDraggableStatus({
          context: 'itinerary',
          data
        })
      );
    } else if (source?.droppableId === TRIP_DAY_LINEITEM_DROPPABLE_ID) {
      dispatch(
        addDraggableStatus({
          context: 'itinerary',
          data: {
            isTripDaysDraggableDisabled: true,
            isDayContentDraggableDisabled: true,
            isLibraryDraggableDisabled: true,
            isDayLineItemDraggableDisabled: false,
            isDayLibraryServiceDraggableDisabled: true
          }
        })
      );
    } else if (source?.droppableId === TRIP_CONTENT_LIST_DROPPABLE_ID) {
      dispatch(
        addDraggableStatus({
          context: 'itinerary',
          data: {
            isLibraryDraggableDisabled: true,
            isTripContentListDraggableDisabled: false,
            isTripContentDataDraggableDisabled: true,
            isDayLibraryServiceDraggableDisabled: true
          }
        })
      );
    } else if (source?.droppableId === TRIP_AMENITIES_TABLE_DROPPABLE_ID) {
      dispatch(
        addDraggableStatus({
          context: 'itinerary',
          data: {
            isLibraryDraggableDisabled: true,
            isTripAmenitiesTableDraggableDisabled: false,
            isDayContentDraggableDisabled: true,
            isTripDaysDraggableDisabled: true,
            isTripContentListDraggableDisabled: true,
            isDayLibraryServiceDraggableDisabled: true
          }
        })
      );
    }
  };

  const onDragEnd = (data) => {
    const { destination, source, draggableId } = data;
    dispatch(addIsDragging({ isDragging: false }));
    dispatch(cleanDraggableStatus());

    //Destination is not set, do nothing
    if (!destination) {
      return;
    }

    //Destination and source are exactly the same, in the same index do nothing
    if (
      destination?.droppableId === source?.droppableId &&
      destination?.index === source?.index
    ) {
      return;
    }

    //It's not allowed to move days items to content library
    if (
      source?.droppableId === TRIP_DAYS_DROPPABLE_ID &&
      destination?.droppableId === CONTENT_LIBRARY_DROPPABLE_ID
    ) {
      return;
    }

    //We are getting the content blocks from the library to add to a new trip day
    if (
      source?.droppableId === CONTENT_LIBRARY_DROPPABLE_ID &&
      destination?.droppableId === TRIP_DAYS_DROPPABLE_ID
    ) {
      dispatch(
        addDraggableAction({
          context: 'itinerary',
          data: {
            type: CREATENEWDAY,
            sourceIndex: source.index,
            destinationIndex: destination.index,
            draggableId
          }
        })
      );
      return;
    }

    //We are getting the content blocks from the library to add a new trip content
    if (
      source?.droppableId === CONTENT_LIBRARY_DROPPABLE_ID &&
      destination?.droppableId === TRIP_CONTENT_LIST_DROPPABLE_ID
    ) {
      dispatch(
        addDraggableAction({
          context: 'itinerary',
          data: {
            type: CREATE_NEW_ADDITIONAL_CONTENT,
            sourceIndex: source.index,
            destinationIndex: destination.index,
            draggableId
          }
        })
      );
      return;
    }

    //We are getting the content blocks from the library to update a trip day
    if (
      source?.droppableId === CONTENT_LIBRARY_DROPPABLE_ID &&
      destination?.droppableId === TRIP_DAY_CONTENT_DROPPABLE_ID
    ) {
      dispatch(
        addDraggableAction({
          context: 'itinerary',
          data: {
            type: UPDATEDAYCONTENT,
            sourceIndex: source.index,
            destinationIndex: destination.index,
            draggableId
          }
        })
      );

      return;
    }

    //We are getting the content blocks from the library to update a trip content
    if (
      source?.droppableId === CONTENT_LIBRARY_DROPPABLE_ID &&
      destination?.droppableId === TRIP_CONTENT_ITEM_DROPPABLE_ID
    ) {
      dispatch(
        addDraggableAction({
          context: 'itinerary',
          data: {
            type: UPDATE_ADDITIONAL_CONTENT,
            sourceIndex: source.index,
            destinationIndex: destination.index,
            draggableId
          }
        })
      );

      return;
    }

    //We are getting amenities from the library to add to the trip amenities table
    if (
      source?.droppableId === CONTENT_LIBRARY_DROPPABLE_ID &&
      destination?.droppableId === TRIP_AMENITIES_TABLE_DROPPABLE_ID
    ) {
      dispatch(
        addDraggableAction({
          context: 'itinerary',
          data: {
            type: ADD_AMENITY_FROM_LIBRARY,
            sourceIndex: source.index,
            destinationIndex: destination.index,
            draggableId
          }
        })
      );
      return;
    }

    //Destination and source are exactly the same for days, but indexes are different, proced to reorganize days
    if (
      source?.droppableId === TRIP_DAYS_DROPPABLE_ID &&
      destination?.droppableId === source?.droppableId &&
      destination?.index !== source?.index
    ) {
      dispatch(
        addDraggableAction({
          context: 'itinerary',
          data: {
            type: REORGANIZEDAYS,
            sourceIndex: source.index,
            destinationIndex: destination.index
          }
        })
      );
      return;
    }

    //Destination and source are exactly the same for content, but indexes are different, proced to reorganize content items
    if (
      source?.droppableId === TRIP_CONTENT_LIST_DROPPABLE_ID &&
      destination?.droppableId === source?.droppableId &&
      destination?.index !== source?.index
    ) {
      dispatch(
        addDraggableAction({
          context: 'itinerary',
          data: {
            type: REORGANIZE_ADDITIONAL_ITEMS,
            sourceIndex: source.index,
            destinationIndex: destination.index
          }
        })
      );
      return;
    }

    //Destination and source are exactly the same for amenities, but indexes are different, proceed to reorganize amenities
    if (
      source?.droppableId === TRIP_AMENITIES_TABLE_DROPPABLE_ID &&
      destination?.droppableId === source?.droppableId &&
      destination?.index !== source?.index
    ) {
      dispatch(
        addDraggableAction({
          context: 'itinerary',
          data: {
            type: REORGANIZE_AMENITIES,
            sourceIndex: source.index,
            destinationIndex: destination.index
          }
        })
      );
      return;
    }

    // We are getting itinerary services from the library to add to the detailed itinerary
    if (
      source?.droppableId === CONTENT_LIBRARY_DROPPABLE_ID &&
      destination?.droppableId === ITINERARY_SERVICE_LIBRARY_DROPPABLE_ID
    ) {
      dispatch(
        addDraggableAction({
          context: 'itinerary',
          data: {
            type: ADD_ITINERARY_SERVICE_FROM_LIBRARY,
            sourceIndex: source.index,
            destinationIndex: destination.index,
            draggableId,
            itineraryserviceid: parseInt(draggableId.split('.')[1], 10)
          }
        })
      );
      return;
    }
  };

  useEffect(() => {
    // For detailed itinerary, additional content and days tab show library button
    if ([0, 1].includes(openedTab)) {
      setsShowLibraryButton(true);
    } else if (openedTab === 5 && ShowServicesFunctionality) {
      setsShowLibraryButton(true);
    } else {
      setsShowLibraryButton(false);
    }
  }, [openedTab, ShowServicesFunctionality]);

  useEffect(() => {
    if (tenant && ldClient) {
      ldClient?.identify({ key: `${tenant.tenantid}` });
    }
  }, [ldClient, tenant]);

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
        <Box
          id={id}
          className='itinerary-wapper'
          data-testid='trip-itinerary'
          {...rest}
        >
          <ImagePicker
            callback={updateTripCoverImage}
            id={`image-picker-component`}
            url={getOldCoverImageUrl(tripImage?.imageurl)}
            tripId={tripid}
            pathReference={pathReference.TRIP}
            fileType={fileType.IMAGE}
          />
          <div className='itinerary-content'>
            <AboutTrip id={`about-trip-component`} />
            <div className='itinerary-description-divider' />
            <div
              className='itinerary-container'
              style={{ minHeight: !shouldLibraryClose ? '600px' : 'auto' }}
            >
              <Box
                className='buttons-container'
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%'
                }}
              >
                <Box sx={{ width: '100%', position: 'relative' }}>
                  {showLibraryButton && (
                    <XGButton
                      data-testid='library-button'
                      className='library-button'
                      id='library-button'
                      text={t('trip:library')}
                      type='secondary'
                      size='large'
                      variant='outlined'
                      onClick={handleSlideOpen}
                      startIcon={<Books size={20} />}
                    />
                  )}

                  <CustomTabs handleTabChange={handleTabChange}>
                    <CustomTab label={t('trip:days')}>
                      <DetailedView id='itinerary-detailed-view' />
                    </CustomTab>
                    <CustomTab label={t('trip:additionalContent')}>
                      <AdditionalContent id='itinerary-trip-additional-content' />
                    </CustomTab>
                    <CustomTab label={t('trip:amenities')}>
                      <Box
                        style={{
                          padding: '24px 0',
                          display: 'flex',
                          flexDirection: 'row',
                          gap: '16px'
                        }}
                      >
                        <XGButton
                          autoFocus
                          id='button-add-amenity'
                          text={t('trip:addAmenity')}
                          type='primary'
                          size='large'
                          variant='contained'
                          onClick={() => setIsAddAmenityFormVisible(true)}
                          startIcon={<PlusCircle size={20} />}
                        />
                        <XGButton
                          autoFocus
                          id='button-saved-amenity'
                          text={t('trip:savedAmenity')}
                          type='secondary'
                          size='large'
                          variant='outlined'
                          onClick={handleSlideOpen}
                          startIcon={<PlusCircle size={20} />}
                        />
                      </Box>
                      <AmenitiesTable
                        amenitiesList={amenitiesList}
                        handleUpdateSequence={handleUpdateSequence}
                        updateAmenity={handleUpdateAmenity}
                        handleDelete={handleDeleteAmenity}
                        isDropDisabled={isSubmitting}
                        isAddAmenityFormVisible={isAddAmenityFormVisible}
                        setAmenitiesList={setAmenitiesList}
                        toggleVisibility={() =>
                          setIsAddAmenityFormVisible(false)
                        }
                        tripid={tripid}
                        droppableId={TRIP_AMENITIES_TABLE_DROPPABLE_ID}
                      />
                    </CustomTab>
                    <CustomTab label={t('settings:passengerFields')}>
                      <TripPassengerFieldsPanel id='trip-passenger-fields-panel' />
                    </CustomTab>
                    {ShowServiceTypes && (
                      <CustomTab label={t('settings:serviceTypes')}>
                        <ServiceTypesTabPanel id='trip-service-types-panel' />
                      </CustomTab>
                    )}
                    {ShowServicesFunctionality && (
                      <CustomTab label={t('trip:detailedItinerary')}>
                        <DetailedItinerary
                          id='detailed-itinerary-view'
                          tripid={tripid}
                          tenant={tenant}
                        />
                      </CustomTab>
                    )}
                  </CustomTabs>
                </Box>
              </Box>
              <LibrarySlide
                key={openedTab}
                openSlide={!shouldLibraryClose}
                handleSlideClose={handleSlideClose}
                openedTab={openedTab}
                showServicesFunctionality={ShowServicesFunctionality}
              />
            </div>
          </div>
        </Box>
      </DragDropContext>
      <DeleteModal
        id='delete-amenity-modal'
        isOpenModal={isDeleteModalOpen}
        title={t('settings:deleteAmenity')}
        onConfirm={handleDeleteAmenityConfirmation}
        onCancel={() => {
          setIsDeleteModalOpen(false);
          setDeleteAmenityId(null);
        }}
        description={`${t('settings:deleteAmenityConfirmation')} ${t(
          'common:thisActionCannotBeUndone'
        )}`}
        isSubmitting={isSubmitting}
      />
    </>
  );
};

Itinerary.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string.isRequired
};

export default Itinerary;
